module.exports = "export default __webpack_public_path__ + &quot;619193160a1062e5e0cc3a69087a54a7.svg&quot;;"